import { render, staticRenderFns } from "./buttons-units.vue?vue&type=template&id=2b286e24&scoped=true&lang=pug&"
import script from "./buttons-units.vue?vue&type=script&lang=js&"
export * from "./buttons-units.vue?vue&type=script&lang=js&"
import style0 from "./buttons-units.vue?vue&type=style&index=0&id=2b286e24&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b286e24",
  null
  
)

export default component.exports